// extracted by mini-css-extract-plugin
export default {"wrapper":"OrdersMobile_wrapper__1zkNd","topGroup":"OrdersMobile_topGroup__36jIg","listWrapper":"OrdersMobile_listWrapper__3NGYh"};